module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Promo_Footer', {

		configure: function (argument) {

			this.registerOptions('', {
				autoRender: true,
				container: '.common-footer',
				template: 'promo_footer',

				widgets: {
					mailChimpApi: {
						widget: 'Api',
						method: 'subscription.subscribe'
					},

					copyright: {
						widget: 'Copyright'
					},

					subscribeMessage: {
						widget: 'Widget',
						container: '.subscribe-message',
						autoRender: false,
						template: 'promo_footer_subscribe_message'
					}
				},

				'handleDom.subscribe': {
					target: '.subscribe',
					event: 'click',
					callback: 'subscribe'
				},

				'handleWom.showSuccessMessage': {
					widget: '#mailChimpApi',
					event: 'success',
					callback: 'showSubscriptionMessage'
				},
				'handleWom.showErrorMessage': {
					widget: '#mailChimpApi',
					event: 'failure',
					callback: 'showSubscriptionMessage'
				},
				'handleWom.messageAdded': {
					widget: '#subscribeMessage',
					event: 'addedToDom',
					callback: 'hideMessage'
				},
			});

			this.callParent('configure', arguments);
		},

		subscribe: function () {
			var isAllowed = true;
			var data = {};
			var fields = fox.dom.select('.subscribe-block .inp', this.element);

			if (fields.length) {
				fox.each(fields, function (input) {
					var value = fox.trim(input.value);
					if (value.length == 0) {
						isAllowed = false;
						return false;
					}
					data[input.name] = input.value;
				})
			}

			if (!isAllowed) {
				return;
			}

			data.type = 'model-subscriber';
			this.rwom1('#mailChimpApi').send(data);
		},

		showSubscriptionMessage: function (resp, api, event) {
			this.wom1('#subscribeMessage').setTemplateOptions('success', event == 'success')
			this.wom1('#subscribeMessage').setTemplateOptions('failure', event == 'failure')
			this.wom1('#subscribeMessage').render();
		},

		hideMessage: function (obj, w, e) {
			var block = fox.dom.wrap(w.element[0]);
			block.addClass('show');

			window.setTimeout(function () {
				block.removeClass('show');
			}, 2000);
		}

	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/promo/footer.js
// module id = 347
// module chunks = 2